import React, { Component } from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';
// import {getDateFormat} from '../../../../Utils/UserFunctions';
// import moment from 'moment';

class OtherComponent extends Component {
    
    render () {
        const {colData,id,header} = this.props;
        
        return(
            <td key={id}>
            {colData.value}
            </td>
        );
    }
}

export default OtherComponent;